import { ReactElement } from "react";
import SubscriberMint from "../../components/SubscriberMint/SubscriberMint";
import MintLayout from "../../components/Layouts/Mint";
import SEO from "../../components/Seo/Seo";

const Subscriber = () => (
  <>
    <SEO title="Subscriber Membership Pass | Coinage Media" />
    <SubscriberMint connectButtonText={"Get Membership Pass"} />
  </>
);

Subscriber.getLayout = function getLayout(page: ReactElement) {
  return (
    <MintLayout hideMenu hideWalletBtn>
      {page}
    </MintLayout>
  );
};

export default Subscriber;
